import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

interface EmptyStateProps {
  /** Legacy — yeni spec icon kullanmaz, ignore edilir. Geriye dönük tutuldu. */
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  /** Daha az dikey alan kapla (kart-içi empty state için). */
  compact?: boolean;
}

/**
 * EmptyState — BRANDBOOK §6.13 (Sprint 28c hed_v3, 13C Lime Nokta).
 *
 * Minimal — 14px lime nokta + 4px lime shadow halo + title + description + action.
 * Büyük illüstrasyon yok (Do/Don't §11).
 */
export function EmptyState({ title, description, action, compact }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3 text-center', compact ? 'p-6' : 'p-12')}>
      <span
        aria-hidden="true"
        className="h-3.5 w-3.5 rounded-full bg-custel-lime"
        style={{ boxShadow: '0 0 0 4px rgba(228, 243, 35, 0.18)' }}
      />
      <h3 className="text-[18px] font-semibold leading-tight text-custel-ink">{title}</h3>
      {description && <p className="max-w-[320px] text-sm leading-[1.5] text-custel-g500">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
